// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: "https://api.kointrack.com",
  // apiUrl: "http://localhost:8000",
  apiKey: "089733c9dfy7yuqjca97rxmzn7e7890",
  appVersionAndroid: 20000,
  appVersionAndroidReadable: "v2.0.0",
  appVersionIos: 200000,
  appVersionIosReadable: "v2.0.0",
  blogApiEndpoint: "https://kointrack.com/",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
